import { URL_SCHEMES as e } from "./url-scheme.mjs";
//#region src/extensions/link-extension/url-scheme-options.ts
var t = (t) => [
	{
		customLabel: t("input.url.site"),
		label: e.https,
		value: e.https
	},
	{
		customLabel: t("input.url.mail"),
		label: e.mailto,
		value: e.mailto
	},
	{
		customLabel: t("input.url.tel"),
		label: e.tel,
		value: e.tel
	}
];
//#endregion
export { t as getUrlSchemeOptions };
